<div class="row pt-3 pl-5">
  <div class="col-lg-4">
    <span class="colorBox m-r-1"></span>
    <h5> <strong>Global Viewability</strong>
      <small><sup>
          <i class="fa fa-info-circle" data-placement="top" data-toggle="tooltip" entooltip=""
            title="The average viewability percentage of valid traffic for all ad sizes and traffic types in the app"
            style="cursor: pointer;"></i>
        </sup></small>
    </h5>
  </div>
</div>
<div class="row pl-5">
  <!--<div class="col-lg-2"><p class="big-number">{{data?.viewabilityDistribution?.viewability | perc:'1.2-2'}} </p></div>-->
  <div class="col-lg-4">
    <h5>
      <ng-container *ngIf="isFreemium && !isFollowing">
        <div class="freemium-lock">
          <i class="fa fa-lock"></i>
        </div>
      </ng-container>
      <ng-container *ngIf="!isFreemium || (isFreemium && isFollowing)">
        {{data?.viewabilityDistribution?.nonGivtSivtViewability | perc:'1.2-2'}}
      </ng-container>
    </h5>
  </div>
</div>
<div class="row text-xs-center" *ngIf="!isFreemium">
  <div class="col-lg-12">
    <app-line-chart [data]="lineChartData" [height]="'400px'" [valueAxisUnit]="'%'" [titleArray]="['Viewability']"
      [categoryField]="'month'" [valueFields]="['nonGivtSivtViewability']"></app-line-chart>
  </div>
</div>
<div class="row mb-1">
  <div class="col-lg-12">
    <app-data-table-component [headers]="headers" [currentSort]="'totalInventoryRatio'" [data]="adSizes">
    </app-data-table-component>
  </div>
</div>
